import React from 'react';

interface ProposalSkeletonProps {
  isMobile?: boolean;
}

export function ProposalSkeleton({ isMobile = false }: ProposalSkeletonProps) {
  if (isMobile) {
    return (
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-4 shadow-sm border border-gray-200/30 animate-pulse">
        <div className="flex items-start space-x-4">
          {/* Avatar */}
          <div className="h-12 w-12 bg-gray-200 rounded-xl flex-shrink-0"></div>
          
          {/* Proposal Details */}
          <div className="flex-1 min-w-0">
            {/* Header Row */}
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1 min-w-0">
                <div className="h-4 bg-gray-200 rounded w-32 mb-1"></div>
                <div className="h-3 bg-gray-100 rounded w-40"></div>
              </div>
              
              {/* Status Badge */}
              <div className="flex-shrink-0 ml-3">
                <div className="h-6 bg-gray-200 rounded-lg w-16"></div>
              </div>
            </div>
            
            {/* Footer Row */}
            <div className="flex items-center justify-end pt-2 border-t border-gray-200/50">
              <div className="h-5 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Desktop skeleton
  return (
    <tr className="animate-pulse">
      <td className="px-8 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="h-10 w-10 bg-gray-200 rounded-xl flex-shrink-0"></div>
          <div className="ml-4">
            <div className="h-4 bg-gray-200 rounded w-32 mb-1"></div>
            <div className="h-3 bg-gray-100 rounded w-40"></div>
          </div>
        </div>
      </td>
      <td className="px-8 py-4 whitespace-nowrap">
        <div className="h-4 bg-gray-200 rounded w-48"></div>
      </td>
      <td className="px-8 py-4 whitespace-nowrap">
        <div className="h-6 bg-gray-200 rounded-lg w-20"></div>
      </td>
      <td className="px-8 py-4 whitespace-nowrap">
        <div className="h-5 bg-gray-200 rounded w-24"></div>
      </td>
    </tr>
  );
}

interface ProposalSkeletonListProps {
  count?: number;
  isMobile?: boolean;
}

export function ProposalSkeletonList({ count = 5, isMobile = false }: ProposalSkeletonListProps) {
  if (isMobile) {
    return (
      <div className="space-y-3">
        {Array.from({ length: count }).map((_, index) => (
          <ProposalSkeleton key={index} isMobile={true} />
        ))}
      </div>
    );
  }

  // Desktop table skeleton
  return (
    <table className="min-w-full divide-y divide-gray-200/60">
      <thead>
        <tr className="animate-pulse">
          <th className="px-8 py-4 text-left">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </th>
          <th className="px-8 py-4 text-left">
            <div className="h-4 bg-gray-200 rounded w-12"></div>
          </th>
          <th className="px-8 py-4 text-left">
            <div className="h-4 bg-gray-200 rounded w-14"></div>
          </th>
          <th className="px-8 py-4 text-left">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200/60">
        {Array.from({ length: count }).map((_, index) => (
          <ProposalSkeleton key={index} isMobile={false} />
        ))}
      </tbody>
    </table>
  );
}
